import React from 'react';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//style
import styles from 'src/asset/scss/style/market.reg.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function MarketRegDataFieldWrapper(props) {
    const { title, children } = props;

	return (
        <div>
            <label>{title}</label>
            <div>{children}</div>
        </div>
	)
}